module.exports = {
	"name": "PS4 Firefox Linux",
	"supported": [
		{
			"id": "054c-05c4-Sony Computer Entertainment Wireless Controller",
			"os": "Linux",
			"browser": "Firefox"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick x": {
			"index": 2
		},
		"right stick y": {
			"index": 5
		},
		"dpad x": {
			"index": 6
		},
		"dpad y": {
			"index": 7
		}
	},
	"buttons": {
		"a": {
			"index": 1
		},
		"x": {
			"index": 0
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"left stick": {
			"index": 10
		},
		"dpad left": {
			"axis": 6,
			"direction": -1
		},
		"dpad right": {
			"axis": 6,
			"direction": 1
		},
		"dpad up": {
			"axis": 7,
			"direction": -1
		},
		"dpad down": {
			"axis": 7,
			"direction": 1
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"y": {
			"index": 3
		},
		"b": {
			"index": 2
		},
		"back": {
			"index": 8
		},
		"start": {
			"index": 9
		},
		"right stick": {
			"index": 11
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick up": {
			"axis": 5,
			"direction": -1
		},
		"right stick down": {
			"axis": 5,
			"direction": 1
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/ps4-ff-linux.json
// module id = 212
// module chunks = 0